import BananaScreen1D from './BananaScreen_1D.png';
import BananaScreen2D from './BananaScreen_2D.png';

export const getImageBananaScreen = (nbrOfDecks: number) => {
  if (nbrOfDecks === 2) {
    return BananaScreen2D;
  } else {
    return BananaScreen1D;
  }
};
